import { useLocation } from 'react-router';

export default function useQueryString() {
	const { search } = useLocation();
	return {
		params: new URLSearchParams(search),
		raw: search,
	};
}

